import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivityComponent } from './components/Activity/activity.component';
import { InvestigationComponent } from './components/Investigation/investigation.component';
import { NgxPermissionsGuard } from 'ngx-permissions';

const routes: Routes = [
    {
        path: 'activity',
        component: ActivityComponent,
        canActivate: [NgxPermissionsGuard]
    },
    {
        path: 'activity/:activityId/investigation/:investigationId',
        component: InvestigationComponent,
        canActivate: [NgxPermissionsGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class VehicleFileRoutes { }



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Vehicle-file/vehicle-file.routes.ts